import { ISummarySalon } from 'features/report/services/types/reportStaff';
import { get } from 'lodash';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import average_ticket_icon from './icons/average-ticket.svg';
import gross_sales_icon from './icons/gross-sales.svg';
import tip_icon from './icons/tip.svg';
import card_fee_icon from './icons/card-fees.svg';
import transaction_icon from './icons/transaction.svg';
import discount_icon from './icons/discount.png';
import SalesOverview from './components/SalesOverview';

const DashboardSalaryTypes = {
  TOTAL_SALE: 'TOTAL_SALE',
  TOTAL_DISCOUNT: 'TOTAL_DISCOUNT',
  TOTAL_TIPS: 'TOTAL_TIPS',
  CARD_FEES: 'CARD_FEES',
  TRANSACTION: 'TRANSACTION',
  AVERAGE_TICKET: 'AVERAGE_TICKET',
};
const configs = {
  [DashboardSalaryTypes.TOTAL_SALE]: {
    label: 'Total Sale',
    bg: '#808836',
    icon: gross_sales_icon,
  },
  [DashboardSalaryTypes.TOTAL_DISCOUNT]: {
    label: 'Total Discount',
    bg: '#C52884',
    icon: discount_icon,
  },
  [DashboardSalaryTypes.TOTAL_TIPS]: {
    label: 'Total Tips',
    bg: '#4F1787',
    icon: tip_icon,
  },
  [DashboardSalaryTypes.CARD_FEES]: {
    label: 'Card Fees',
    bg: '#C84B31',
    icon: card_fee_icon,
  },

  [DashboardSalaryTypes.TRANSACTION]: {
    label: 'Transactions',
    bg: '#C52884',
    icon: transaction_icon,
  },
  [DashboardSalaryTypes.AVERAGE_TICKET]: {
    label: 'Average Ticket',
    bg: '#346751',
    icon: average_ticket_icon,
  },
};

type Props = {
  dataSale: ISummarySalon;
};
const SummarySalonReportV2 = ({ dataSale }: Props) => {
  return (
    <Container>
      <ContainerStatistic>
        <DashboardItem type='TOTAL_SALE' value={formatCurrency(dataSale.crossSales)} />
        <DashboardItem type='TOTAL_DISCOUNT' value={formatCurrency(dataSale.discount)} />
        <DashboardItem type='TOTAL_TIPS' value={formatCurrency(dataSale.tip)} />
        <DashboardItem type='CARD_FEES' value={formatCurrency(dataSale.cardFee)} />
        <DashboardItem type='TRANSACTION' value={dataSale?.transactions?.toString()} />
        <DashboardItem type='AVERAGE_TICKET' value={formatCurrency(dataSale.averageTicket)} />
      </ContainerStatistic>
      {/* <ProcessReportV2 list={dataProgressList} listTotal={listTotal} /> */}
      <SalesOverview />
    </Container>
  );
};

export default SummarySalonReportV2;
const DiscountContainer = styled.div`
display: flex;
padding: 8px 16px;
flex-direction: column;
align-items: flex-start;
gap: 4px;
align-self: stretch;
background: #F5F5F5;
.deduction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}
.content-item {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  span.label {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  span.value {
    color: #1D2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    text-transform: capitalize;
  }
}
`;
const ContainerStatistic = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 16px;
  align-self: stretch;
`;
const Container = styled.div`
  padding: 24px 16px;
  align-self: stretch;
  gap: 16px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
`;

type DashboardItemProps = {
  type: keyof typeof DashboardSalaryTypes;
  value: string;
  style?: React.CSSProperties;
};
const DashboardItem = ({ type, value, style }: DashboardItemProps) => {
  const config = get(configs, type);
  if (!config) return null;
  return <DashboardItemStyled style={style} className={type}>
    <div className="content">
      <p className="label">{config.label}</p>
      <p className="value">{value}</p>
    </div>

    <div className="icon-button">
      <img src={config.icon} alt={config.label} />
    </div>

  </DashboardItemStyled>;
};
const DashboardItemStyled = styled.div`
display: flex;
padding: 24px;
align-items: center;
gap: 8px;
flex: 1 0 0;
border-radius: 8px;
border: 1px solid #CCD4DC;
background: #FFF;
position: relative;
align-self: stretch;
justify-content: space-between;

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  p.label {
    align-self: stretch;
    color: #505050;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
  p.value {
    align-self: stretch;
    color: #1D2129;
    font-family: Poppins;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
}

.icon-button {
  img {
    height: 72px;
    width: 72px;
  }
}

`;
